import { type PeerJSOption } from 'peerjs';

export const peerJsOptions: PeerJSOption = {
  host: import.meta.env.VITE_PEERJS_SERVER_HOST as string,
  port: parseInt(import.meta.env.VITE_PEERJS_SERVER_PORT as string),
  path: import.meta.env.VITE_PEERJS_SERVER_PATH as string,
  config: {
    iceServers: [
      { urls: import.meta.env.VITE_STUN_SERVER_URI as string },
      {
        urls: import.meta.env.VITE_TURN_SERVER_URI as string,
        username: import.meta.env.VITE_TURN_SERVER_USERNAME as string,
        credential: import.meta.env.VITE_TURN_SERVER_PASSWORD as string,
      },
    ],
  },
  debug: 0,
};
